<div #userInfoBox [matMenuTriggerFor]="menu" class="px-3 sen-cursor-pointer sen-user-info bg-white sen-personIconSize" fxLayout="row"
    fxLayoutAlign="space-between center">
    <mat-icon>person</mat-icon>
    <h5 class="mb-0">{{global.sCustomerID}}</h5>
    <mat-icon>arrow_drop_down</mat-icon>
</div>
<mat-menu #menu="matMenu">
    <span class="sen-cursor-pointer" [matMenuTriggerFor]="subMenu" mat-menu-item
        [ngStyle]="{'width': getUserInfoWidth()}">
        <mat-icon>language</mat-icon>
        <span *ngIf="global.sLanguage == global.deString">{{translate.getLng('LANGUAGE_DE')}}</span>
        <span *ngIf="global.sLanguage == global.enString">{{translate.getLng('LANGUAGE_EN')}}</span>
    </span>
    <span (click)="goToSettingPath()" class="sen-cursor-pointer" mat-menu-item>
        <mat-icon>settings</mat-icon> {{translate.getLng('SETTINGS')}}
    </span>
    <span class="sen-cursor-pointer" mat-menu-item (click)="logoutUser()">
        <mat-icon>power_settings_new</mat-icon> {{translate.getLng('LOGOUT_STRING')}}
    </span>
</mat-menu>

<mat-menu #subMenu="matMenu">
    <span *ngIf="global.sLanguage == global.enString" class="sen-cursor-pointer" mat-menu-item
        (click)="switchLng(global.deString)">
        <mat-icon>language</mat-icon> {{translate.getLng('LANGUAGE_DE')}}
    </span>
    <span *ngIf="global.sLanguage == global.deString" class="sen-cursor-pointer" mat-menu-item
        (click)="switchLng(global.enString)">
        <mat-icon>language</mat-icon> {{translate.getLng('LANGUAGE_EN')}}
    </span>
</mat-menu>
